import { useCallback, useState } from 'react'
import { useRecoilValue } from 'recoil'
import articleSearchTagsTableFields from './articleSearchTagsTable.fields'
import articleSearchTagsAtom from '../../searchTags.atom'
import ArticleSearchTagsFilters from './components/ArticleSearchTagsFilters'
import ArticleSearchTagsHeader from './components/ArticleSearchTagsHeader/indext'
import ArticleSearchTagModal from '../ArticleSearchTagModal'
import useTableWithRequest from '../../../../../../../shared/Table/useTableWithRequest'
import faqApi from '../../../../faq.api'
import useItemsSetter from '../../../../../../../recoil/useItemsSetter'
import useDebounce from '../../../../../../../shared/hooks/useDebounce'
import { IFaqArticleSearchTag } from 'screens/Admin/KnowleageBase/faq.types'
import Table from '../../../../../../../shared/Table'

const ArticleSearchTagsTable = () => {
  const [tagId, setTagId] = useState<number | null>(null)

  const articleSearchTagsState = useRecoilValue(articleSearchTagsAtom)

  const debouncedSearch = useDebounce(articleSearchTagsState.filters.search, 300)

  const dataFetcher = useCallback(
    (params: Record<string, any>) => {
      return faqApi.getArticleSearchTags({
        ...params,
        search: debouncedSearch,
      })
    },
    [debouncedSearch, articleSearchTagsState.filters.forceReload]
  )

  const itemsSetter = useItemsSetter(articleSearchTagsAtom)

  const tableCtrl = useTableWithRequest({
    dataFetcher,
    abortFetching: faqApi.getArticleSearchTags.abort,
    itemKey: 'id',
    fields: articleSearchTagsTableFields,
    items: articleSearchTagsState.items,
    setItems: itemsSetter,
    tableKey: 'articleSearchTags',
    serverSideOrder: true,
  })

  const selected = tableCtrl.orderedItems.filter((it) => tableCtrl.selectedCtrl.selectedIndexes.has(it.id as any))

  const handleClick = useCallback((tag: IFaqArticleSearchTag) => {
    setTagId(tag.id)
  }, [])

  return (
    <>
      <ArticleSearchTagsHeader selected={selected} />
      <ArticleSearchTagsFilters />
      <Table
        {...tableCtrl}
        items={tableCtrl.orderedItems}
        handleSelect={tableCtrl.selectedCtrl.setSelected}
        selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof IFaqArticleSearchTag>}
        handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
        onCLick={handleClick}
        itemKey='id'
      />
      {Boolean(tagId) && <ArticleSearchTagModal tagId={tagId} onClose={() => setTagId(null)} />}
    </>
  )
}

export default ArticleSearchTagsTable
